import React from 'react';

interface CategoryFilterProps {
  categories: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  isLoading?: boolean;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  activeFilter,
  onFilterChange,
  isLoading = false
}) => {
  if (isLoading) {
    return <div className="text-gray-600">Loading categories...</div>;
  }

  if (!categories.length) {
    return <div className="text-gray-600">No categories available</div>;
  }

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 md:pb-0 md:flex-wrap md:justify-center 
      scrollbar-none -mx-4 px-4 md:mx-0 md:px-0">
      {['All', ...categories].map(category => (
        <button
          key={category}
          onClick={() => onFilterChange(category)}
          className={`
            whitespace-nowrap px-6 py-3 rounded-xl transition-all duration-300
            text-sm md:text-base flex-shrink-0
            ${activeFilter === category 
              ? 'bg-white/80 text-gray-800 border-2 border-orange-500'
              : 'bg-white/80 text-gray-800 border-2 border-gray-200 hover:border-orange-300'}
          `}
        >
          {category}
        </button>
      ))}
    </div>
  );
}; 